"use client";

import {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

export interface IDashboardListing {
  shown: number;
  total: number;
}

interface IDashboardListingContext {
  listing: IDashboardListing | null;
  setListing: (listing: IDashboardListing) => void;
}

const DashboardListingContext = createContext<IDashboardListingContext>({
  listing: null,
  setListing: () => {},
});

interface IDashboardListingProviderProps {
  children: ReactNode;
}

export const DashboardListingProvider = ({
  children,
}: IDashboardListingProviderProps) => {
  const [listing, setListing] = useState<IDashboardListing | null>(null);

  const value = useMemo(() => ({ listing, setListing }), [listing]);

  return (
    <DashboardListingContext.Provider value={value}>
      {children}
    </DashboardListingContext.Provider>
  );
};

export const useDashboardListing = (): IDashboardListingContext =>
  useContext(DashboardListingContext);
